<template>
  <div class="phone-yk-radio-que-wrapper">
    <el-form ref="formOption" label-width="70px" class="yk-multiselect-s-wrapper">
      <el-form-item label="题目：" style="background:#fff;margin-bottom:0">
        <span v-if="!isShow">{{li.ContentText}}</span>
        <p v-if="isShow" class="p-title-text">{{li.ContentText}}</p>
      </el-form-item>
      <el-form-item
        label="选项："
        v-if="li.questionType==3"
        :disabled="isShow"
        style="background:#fff;margin-bottom:0"
      >
        <!-- <el-radio-group> -->
        <span style="margin-right:24px;">正确</span>
        <span>错误</span>
        <!-- </el-radio-group> -->
      </el-form-item>
      <el-form-item label="选项：" v-else :disabled="isShow" style="background:#fff;margin-bottom:0">
        <!-- <el-radio-group> -->
        <span style="margin-right:24px;">赞成</span>
        <span>反对</span>
        <!-- </el-radio-group> -->
      </el-form-item>
      <el-button type="primary" v-show="isquestion" @click="save()">保存</el-button>
    </el-form>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "faceteach-true-false",
  props: {
    isBook: {
      type: Boolean,
      default: true
    },
    queTitle: {
      type: String,
      default: ""
    },
    queFaceId: {
      type: String,
      default: ""
    },
    questionnaireId: {
      type: String,
      default: ""
    },
    queId: {
      type: String,
      default: ""
    },
    quesType: {
      type: Number,
      default: 3
    },
    quesOrder: {
      type: Number,
      default: 1
    },
    courseId: {
      type: String,
      default: ""
    },
    courseOpenId: {
      type: String,
      default: ""
    },
    iSubmit: {
      type: Boolean,
      default: false
    },
    isquestion: {
      type: Boolean,
      default: true
    },
    li: {
      type: Object,
      default: {
        questionId: "",
        ContentText: "",
        dataJson: [
          {
            Content: "正确"
          },
          {
            Content: "错误"
          }
        ],
        questionType: 3,
        sortOrder: 1
      }
    }
  },
  data() {
    return {
      thisTitle: "",
      isShow: false
    };
  },
  watch: {
    iSubmit: function(val) {
      if (val) {
        this.checkSubmit();
      }
    },
    queTitle: function(val) {
      this.thisTitle = this.queTitle;
    }
  },
  methods: {
    saveQuestion(type) {
      let title = this.queTitle;
      let dataJson = [
        { Content: "正确", SortOrder: 0 },
        { Content: "错误", SortOrder: 1 }
      ];
      if (this.quesType == 4) {
        dataJson = [
          { Content: "赞成", SortOrder: 0 },
          { Content: "反对", SortOrder: 1 }
        ];
      }
      let stringJson = JSON.stringify(dataJson);
      let activityId = this.queFaceId;
      let questionnaireId = this.questionnaireId;
      let questionId = this.queId;
      var that = this;
      this.$http
        .post("/api/XOrg/BookMaterial/addQuestionnaireDetail", {
          questionnaireId: questionnaireId,
          questionId: questionId,
          title: title,
          dataJson: stringJson,
          answer: "",
          questionType: this.quesType,
          sortOrder: this.quesOrder
        })
        .then(function(rst) {
          if (rst.code > 0) {
            if (type == 1) {
              that.$emit("done", { code: 1 });
            } else {
              that.$emit("updatePage", {});
              that.$message(rst.msg);
            }
          } else {
            that.$message(rst.msg);
          }
        });
    },
    saveCourseQuest: function() {
      let dataJson = [
        { Content: "正确", SortOrder: 0 },
        { Content: "错误", SortOrder: 1 }
      ];
      if (this.quesType == 4) {
        dataJson = [
          { Content: "赞成", SortOrder: 0 },
          { Content: "反对", SortOrder: 1 }
        ];
      }
      let questionnaireId = this.questionnaireId;
      let questionId = this.queId;
      let title = this.queTitle;
      let stringJson = JSON.stringify(this.dataJson);
      let questionType = this.quesType;
      var that = this;
      this.$http
        .post("/api/XOrg/BookMaterial/saveCourseQuest", {
          courseId: that.courseId,
          courseOpenId: that.courseOpenId,
          questionnaireId: questionnaireId,
          questionId: questionId,
          title: title,
          dataJson: stringJson,
          answer: "",
          questionType: questionType
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.$emit("updatePage", {});
          }
          that.$message(rst.msg);
        });
    },
    save: function() {
      if (this.queFaceId == "" || this.queFaceId == null) {
        this.saveCourseQuest();
      } else {
        this.saveQuestion(2);
      }
    },
    checkSubmit: function() {
      if (this.li.ContentText == "") {
        this.$emit("submit", {
          code: 0,
          count: 1,
          msg: "第" + this.li.sortOrder + "题标题为空"
        });
        return;
      }
      this.$emit("submit", { code: 1, count: 1, msg: "success" });
    }
  },
  created() {
    this.thisTitle = this.queTitle;
  },
  mounted() {
    let path = this.$route.path;
    if (path.indexOf("ShareSurveyCourseView") != -1) {
      this.isShow = true;
    }
  }
};
</script>

<style lang="scss" scoped>
// @import "~theme/page/components/variables.scss";
</style>
